import { Search } from '@mui/icons-material';
import { InputBase, Paper } from '@mui/material';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useDebounce from 'Global/Hooks/useDebounce/useDebounce';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const PatientSearchBox = ({
  setSearchAndDeliver,
  languageArray,
  disableObjOutPut = false,
}) => {
  const [searchIdPatient, setSearchIdPatient] =
    useState('');

  const { t, i18n } = useTranslation();

  const data = useDebounce(searchIdPatient, 1);

  useEffect(() => {
    if (data !== null) {
      if (disableObjOutPut) {
        setSearchAndDeliver(data);
        return;
      }
      setSearchAndDeliver((prev) => ({
        ...prev,
        PatientSearchClause: data,
      }));
    }
  }, [data]);

  return (
    <React.Fragment>
      <Paper
        component="form"
        sx={{
          p: '2px 4px',
          display: 'flex',
          alignItems: 'center',
          marginTop: '2em',
          flexDirection:
            i18n?.language === 'en' && 'row-reverse',
          minHeight: '40px',
        }}
        className="current-patient-search-layout-color"
      >
        <InputBase
          size="small"
          sx={{ ml: 1, flex: 1, minHeight: '40px' }}
          placeholder={FindLangKey(
            'current-patients-search-bar',
            languageArray
          )}
          inputProps={{
            'aria-label': FindLangKey(
              'current-patients-search-bar',
              languageArray
            ),
          }}
          onChange={(e) =>
            setSearchIdPatient(e.target.value)
          }
        />
        <Search />
      </Paper>
    </React.Fragment>
  );
};

export default PatientSearchBox;
